import * as z from 'zod/v4';

export const countryIdSchema = z.number().int().nonnegative().brand<'CountryId'>();

export type CountryId = z.infer<typeof countryIdSchema>;

/**
 * Zod schema for Country entity
 */
export const countrySchema = z.object({
  countryId: countryIdSchema,
  name: z.string(),
  isoCode: z.string(),
});

/**
 * TS Country type
 */
export type Country = z.infer<typeof countrySchema>;
